import { Component, OnInit, ViewChild } from '@angular/core';
import { ScatterPeriod } from 'src/app/models/obs/scatterPeriod';
import { Tematic } from 'src/app/models/obs/tematic';
import { Tier3 } from 'src/app/models/obs/tier3';
import { ScatterComponent } from '../../shared/gr/scatter/scatter.component';
import { ScatterPointsService } from 'src/app/services/obs/scatter-points.service';
import { ScatterPeriodService } from 'src/app/services/obs/scatter-period.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';
import { ResponseTematic } from 'src/app/models/obs/apiResponse';
import { Message } from 'src/app/models/message';


@Component({
  selector: 'app-globalop',
  templateUrl: './globalop.component.html',
  styleUrl: './globalop.component.scss'
})
export class GlobalopComponent implements OnInit {

  idTier1: string = '3';/* id tier1 para cargar info en slider */
  selectedItem: number = 4;
  msg: Message;

  idtier1: string = '4';
  scatterperiod: ScatterPeriod[] = [];
  scatterpoint: any[];
  tem: Tematic[];
  t3: Tier3[];
  dx1: number = 0; //  Dominio del gráfico
  dx2: number = 0; // Dominio del gráfico
  dy1: number = 0; //  Dominio del gráfico
  dy2: number = 0; // Dominio del gráfico
  url: string = '#'; //Enlace de reporte a descargar
  selectedDate: string | null = null;
  selectedPeriod: any | null = null;
  originalSelectedDate: string | null = null;
  latestPeriodData: any; // Declara una variable para almacenar los datos del periodo más reciente
  band: string = 'opp';

  @ViewChild(ScatterComponent, { static: false }) scatterComponent: ScatterComponent;

  constructor(
    private scatterpointS: ScatterPointsService,
    private scatterperiodS: ScatterPeriodService,
    private tematicService: TematicService,
    private errorService: ErrorHandlingService,
  ) { }

  ngOnInit() {
    this.getAllScatterPeriod();
    this.getTematic();
  }


  getTematic() {
    this.tematicService.getAll().subscribe({
      next: res => { this.tem = res['data']; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  getAllScatterPeriod() {
    this.scatterperiodS.getAllByIdT1(this.idtier1).subscribe({
      next: res => {
        this.scatterperiod = res['data']
        const latestPeriod = this.findLatestPeriod(this.scatterperiod);
        if (latestPeriod) {
          this.latestPeriodData = latestPeriod;
          this.onDateSelected(this.latestPeriodData)
        }
      },
      error: err => { }
    })
  }

  getByT1AndYear(idTier1: string, year: string) {
    this.scatterpoint = [];
    this.t3 = [];
    this.scatterpointS.getAllByIdTier1AndYear(idTier1, year).subscribe({
      next: res => {
        this.scatterpoint = res['data'];
      },
      error: (err) => {
        this.msg = this.errorService.handleError(err);
      }
    });
  }

  onDateSelected(selectedDate: any) {
    this.selectedPeriod = selectedDate;
    this.selectedItem = selectedDate.id;
    if (selectedDate) {
      const updatedYearBD = this.calculateUpdatedYear(selectedDate['period']);
      this.dx1 = selectedDate['xi'];
      this.dx2 = selectedDate['xf'];
      this.dy1 = selectedDate['yi'];
      this.dy2 = selectedDate['yf'];
      this.url = selectedDate['url']; //obtener el enlace de descarga del reporte
      this.getByT1AndYear(this.idtier1, updatedYearBD);
    }
  }

  //Este lo usamos para calcular el periodo de recojo e informacion y mostrar el periodo de publicacion
  calculateUpdatedYear(period: string): string {
    const year = parseInt(period, 10);
    const updatedYear = year - 1;
    const updatedYearBD = updatedYear.toString();
    return updatedYearBD;
  }

  //Este lo usaremos para obtener el periodo mas reciente y desde aca partimos con la inf de los demas componentes
  findLatestPeriod(periods: any[]): any {
    let latestPeriod = null;
    let latestYear = 0;

    for (const period of periods) {
      const year = parseInt(period['period']);
      if (year > latestYear) {
        latestYear = year;
        latestPeriod = period;
      }
    }

    return latestPeriod;
  }

}

